var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('room-style-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var iconStyle = ref.iconStyle;
return [_c('i',{staticClass:"ws-icon",style:(iconStyle),on:{"click":function($event){return _vm.$emit('click')}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }